<template>
    <client-page class="wrap--mypage">
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">작품검색</h2>
            </div>
            <v-row>
                <v-col cols="12" lg="3">
                    <auction-search-filter v-bind="{ keyword }" />
                </v-col>
                <v-col cols="12" lg="9">
                    <div class="mb-20 mb-md-30">
                        <v-row align="center" justify-md="space-between" class="row--x-small">
                            <v-col cols="12" md="auto">
                                <div class="mb-4 mb-md-0">
                                    <span class="font-size-16 grey-68--text">
                                        {{ keyword ? `${keyword}에 대한` : "전체" }} 검색결과 <span class="font-weight-bold primary--text">{{ totalCount }}</span>건
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto">
                                <auction-search-sort v-bind="{ totalCount }" />
                            </v-col>
                        </v-row>
                    </div>

                    <v-divider class="primary" />
                    <template v-for="work in works">
                        <auction-search-item :key="work._id" :work="work" />
                        <v-divider class="grey-da" :key="`${work._id}-divider`" />
                    </template>
                    <div class="v-pagination-wrap">
                        <v-pagination :value="page" :length="pageCount" :total-visible="11" @input="(page) => $router.push({ query: { ...this.$route.query, page } })" />
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import AuctionSearchItem from "@/components/client/ko/auction/auction-search-item.vue";
import AuctionSearchSort from "@/components/client/ko/auction/auction-search-sort.vue";
import AuctionSearchFilter from "@/components/client/ko/auction/auction-search-filter.vue";

import api from "@/api";
import { AUCTION_PROGRAM_HALLS } from "@/assets/variables";
const halls = Object.values(AUCTION_PROGRAM_HALLS);

export default {
    components: {
        ClientPage,
        AuctionSearchItem,
        AuctionSearchSort,
        AuctionSearchFilter,
    },
    props: {
        keyword: { type: String, default: null },
    },
    data() {
        return {
            loading: false,

            program: null,
            works: [],

            totalCount: 0,
            limit: 10,
        };
    },
    computed: {
        auctionStates() {
            return this.$route.query.auctionStates;
        },
        auctionCategories() {
            return this.$route.query.auctionCategories ? [this.$route.query.auctionCategories].flat() : undefined;
        },
        sort() {
            return this.$route.query.sort || "created_at_desc";
        },
        searchKey() {
            return this.$route.query.searchKey || null;
        },
        searchValue() {
            return this.keyword;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        headers() {
            const { skip, limit } = this;
            return { skip, limit };
        },
        params() {
            let { sort, searchKey, searchValue, auctionStates, auctionCategories } = this;

            return {
                sort,
                searchKey,
                searchValue,
                auctionStates,
                auctionCategories,
            };
        },
    },
    mounted() {
        this.loading = true;
        this.init()
            .then(this.search)
            .finally(() => (this.loading = false));
    },
    watch: {
        auctionStates() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        auctionCategories() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        hall() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        sort() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        page() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        searchKey() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
        searchValue() {
            if (!this.loading) {
                this.loading = true;
                this.init()
                    .then(this.search)
                    .finally(() => (this.loading = false));
            }
        },
    },
    methods: {
        async init() {
            this.works = [];
        },
        async search() {
            const { headers, params } = this;
            var {
                summary: { totalCount },
                works,
            } = await api.v1.auction.works.gets({ headers, params });

            this.works = works;
            this.totalCount = totalCount;
        },
    },
};
</script>
